import angular from 'angular';
import uiRouter from 'angular-ui-router';
import workersComponent from './workers.component';
import dataTable from 'angular-material-data-table';

let workersModule = angular.module('workers', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('workers', {
        url: '/workers',
        component: 'workers',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('workers', workersComponent)
.name;

export default workersModule;
